<template>
	<div
		class="service-card shadow-3 position-relative cursor-pointer"
		@click="handleOpenPopUp"
	>
		<div class="mb-2 d-flex align-items-center">
			<span class="d-flex">
				<slot name="icon"></slot>
			</span>
			<span class="ms-2">
				<slot name="title"></slot>
			</span>
		</div>

		<!-- <slot name="image"></slot> -->

		<div
			ref="contentWrapper"
			class="card-content position-relative show-more-less-text"
		>
			<slot name="content"></slot>
		</div>
		<div class="cursor-pointer open-popup-button position-absolute">
			<u class="link-large-underline link-default">{{
				content.planner_prestationsMoreInfo
			}}</u>
			<svg color="#0042b8" width="10" height="10" class="icon">
				<use href="#___icon___chevron-right-bold"></use>
			</svg>
		</div>
		<PopupBase
			v-if="advantage.popUpComponent"
			:open="isPopUpOpen"
			@closePopup="handleClosePopUp"
		>
			<component
				@closePopup="handleClosePopUp"
				:is="advantage.popUpComponent"
				:advantage="props.advantage"
			></component>
		</PopupBase>
	</div>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick } from "vue"
import type { Ref } from "vue"

// Classe
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess"
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage"

// Components
import PopupBase from "@/vue/common/popupBase.vue"

// Max lines
const MAX_LINES = 5

// Content
const content: any = (window as any).content
const contentWrapper = ref<HTMLElement|null>(null)

// Props
const props = defineProps<{
	refName: string
	advantage: ClubAdvantage
}>()

// Refs
const restauration = ref(null)
const animation = ref(null)
const wellBeing = ref(null)
const InfantClub = ref(null)
const isPopUpOpen = ref(false)


// Methods

function handleOpenPopUp() { isPopUpOpen.value = true }
function handleClosePopUp() { isPopUpOpen.value = false }

const initTextShowMoreLess = (): void => {
	if (restauration.value) {
		const restaurationTextShowMoreLess = new TextShowMoreLess(
			restauration.value,
			MAX_LINES
		)
		restaurationTextShowMoreLess.init()
	}
	if (animation.value) {
		const animationTextShowMoreLess = new TextShowMoreLess(
			animation.value,
			MAX_LINES
		)
		animationTextShowMoreLess.init()
	}
	if (wellBeing.value) {
		const wellBeingTextShowMoreLess = new TextShowMoreLess(
			wellBeing.value,
			MAX_LINES
		)
		wellBeingTextShowMoreLess.init()
	}
	if (InfantClub.value) {
		const InfantClubTextShowMoreLess = new TextShowMoreLess(
			InfantClub.value,
			MAX_LINES
		)
		InfantClubTextShowMoreLess.init()
	}
}

onMounted(async() => {
	await nextTick()
	if (contentWrapper.value) {
		new TextShowMoreLess(contentWrapper.value, MAX_LINES).init()
	}
})
</script>

<style scoped>
.service-card {
	width: 270px;
	height: 260px;
	padding: 20px;
	border-radius: 16px;
	/* gap: 10px; */
}

.open-popup-button {
	bottom: 10px;
	right: 20px;
}

.card-content.show-more-less-text {
  /* fallback clamp if JS fails: */
  overflow: hidden;
}

@media (max-width: 768px) {
	.service-card {
		width: 100%;
	}
}
</style>
